import AppService, { AlertService, Utilities } from 's2s-app-service';

import LoggingService from 's2s-logging-service';

const doGetUserContacts = () => {
  return (dispatch, getState) =>{
    const store = getState();

    // Make appService speak call to get user contacts
    AppService.getInstance().speak('listContacts', {}).then((contactData)=>{
      //console.log('GOT MY CONTACTS! ->', contactData);
      // only add the contact items to the store...metadata is not needed
      dispatch({
        type: 'RECEIVE_CONTACTS_DATA',
        payload: contactData
      });
    });
  };
};

const doShowContactDetails = (contactUuid, history) => {
  return ((dispatch, getState)=>{
    // Set the currentContact in the app store
    dispatch({
      'type': 'SET_CURRENT_CONTACT',
      'payload': {'contactUuid': contactUuid}
    });

    // go to contactdetails route
    history.push('/appmain/contactdetails');
  });
};

const doAddContact = (contactObj, history) => {
  return ((dispatch, getState) => {

  AppService.getInstance().speak("createUserContact", contactObj)
    .then((data) => {

      dispatch({
        'type': 'ADD_CONTACT',
        'payload': {data: data}
      });

      dispatch({
        'type': 'SET_CURRENT_CONTACT',
        'payload': {'contactUuid': data.uuid }
      });



    }).catch((e) => {
      AlertService.getInstance().createErrorAlert(
              {'alertHeadingText': Utilities.getInstance().getIntlMessage('ALERT_ERROR_ADDING_CONTACT_HEADING', 'Error Adding Contact'),
               'alertBodyText': Utilities.getInstance().getIntlMessage('ALERT_ERROR_ADDING_CONTACT_BODY', 'Please try again.  If problem persists call technical support'), isPersistent: false});
    });

    history.goBack();
  });
};

const doUpdateContact = (contactObj) => {
  return ((dispatch, getState) => {

    // Call api to update the contact data
    AppService.getInstance().speak("updateContact", {"contact_uuid": contactObj.uuid, ...contactObj})
      .then((data) => {
        dispatch({
          'type': 'UPDATE_CONTACT',
          'payload': {data: data}
        });

      }).catch((e) => {
        AlertService.getInstance().createErrorAlert(
                {alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT_ERROR_UPDATING_CONTACT_HEADING', 'Error Updating Contact'),
                 'alertBodyText': Utilities.getInstance().getIntlMessage('ALERT_ERROR_UPDATING_CONTACT_BODY', 'Please try again.  If problem persists call technical support'), isPersistent: false});
      });
  });

};

const doDeleteContact = (contact_uuid, history) => {
  return ((dispatch, getState) => {
    // Call api to delete the contact
    AppService.getInstance().speak("deleteContact", {"contact_uuid": contact_uuid})
      .then((data) => {

        dispatch({
          type: 'DELETE_CONTACT',
          payload: contact_uuid
        });

      }).catch((e) => {
        AlertService.getInstance().createErrorAlert(
                {alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT_ERROR_ADDING_CONTACT_HEADING', 'Error Deleting Contact'),
                 alertBodyText: Utilities.getInstance().getIntlMessage('ALERT_ERROR_DELETING_CONTACT_BODY', 'Please try again.  If problem persists call technical support'), isPersistent: false});
      });
      //history.push('/appmain/contactlist')
      history.goBack();
  });
};

// NOTE: From the ContactDetails route where this is called, history.goBack() can only go back to ContactList
const doGoBackToContactList = (history) => {
  return ((dispatch, getState) => {
    history.goBack();
  });
};

const doGoToNewContactForm = (history) => {
  return ((dispatch, getState) => {
    history.push('/appmain/contactdetails/new');
});
};


export { doGetUserContacts, doShowContactDetails, doAddContact, doUpdateContact, doDeleteContact, doGoBackToContactList, doGoToNewContactForm };



// WEBPACK FOOTER //
// ./src/action-creators/contacts.js